import React from 'react'
const isClassComponent = (component) => {
    return (
        typeof component === 'function' &&
        !!component.prototype.isReactComponent
    )
}

const isFunctionComponent = (component) => {
    return (
        typeof component === 'function' &&
        String(component).includes('return React.createElement')
    )
}

export const isReactComponent = (component) =>{
    return (
        isClassComponent(component) ||
        isFunctionComponent(component)
    )
}

export const isElement = (element) => {
    return React.isValidElement(element);
}